import { render, staticRenderFns } from "./FormatSpan.vue?vue&type=template&id=1829bf6f&"
import script from "./FormatSpan.vue?vue&type=script&lang=js&"
export * from "./FormatSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports